import { defineMessages } from 'react-intl';

export default defineMessages({
	lblDOB: {
		id: 'app.common.dateOfBirth.dob',
		defaultMessage: 'Date of Birth',
	},
});
